var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNibpenAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0901 9.62699C20.5915 8.89553 20.4171 7.88873 19.7006 7.37625L13.4639 2.92694C12.746 2.41605 11.7578 2.59344 11.2548 3.32381L10.0519 5.07423L18.8871 11.3774L20.0901 9.62699Z",
    fill: "#0350A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6735 16.1976C10.2158 16.8636 9.3146 17.0255 8.66089 16.5591C8.00701 16.0926 7.8481 15.1745 8.30584 14.5084C8.76369 13.8422 9.66487 13.6803 10.3187 14.1468C10.9725 14.6132 11.1314 15.5314 10.6735 16.1976Z",
    fill: "#0350A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1313 10.7289L11.4842 7.41365L8.24657 8.66297C6.5967 9.2972 5.42763 10.8108 5.21063 12.5937L4 22.4307L7.69782 17.1344C6.80495 16.2013 6.74659 14.7321 7.56244 13.7284C8.37812 12.7246 9.80568 12.5093 10.8719 13.2291C11.9383 13.949 12.3002 15.3724 11.711 16.529C11.1217 17.6859 9.77121 18.2036 8.57966 17.7296L4.89989 23L13.4997 18.5074C15.0699 17.6897 16.0659 16.0529 16.0866 14.2564L16.1313 10.7289Z",
    fill: "#0350A2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNibpenAlt);
export default __webpack_public_path__ + "static/media/nibpen_alt.c32cf6f4054c860d124b7f42c2803a48.svg";
export { ForwardRef as ReactComponent };